export default __webpack_public_path__ + "images/session-bg-1.png?dbd8cd3c5c3ceb0b50782684fc6be077";